import { fileSchema, locationSchema } from "@/types/schema";
import * as z from "zod";

export const createAdvertSchema = z.object({
  prompt: z.string().nullish(),
  description: z.string().min(1, "Required"),
  price: z.coerce.number().optional(),
  discount: z.coerce.number().optional(),
  location: locationSchema.optional(),
  files: fileSchema.array().nullish(),
  externalLinks: z.string().optional(),
  categoryId: z.coerce.number().optional(),
  subCategoryId: z.coerce.number().optional(),
});

export type CreateAdvertSchemaModel = z.infer<typeof createAdvertSchema>;
